/**
 * 취소 주체를 abort 사유에 싣는다. 이름은 AbortError 그대로라 errorCodeOf 가 ABORTED 로
 * 분류하는 경로는 바뀌지 않는다 — 계측(action_end.cancel_by)만 message 로 주체를 읽는다.
 */
import { type QuestionCardAiCancelBy } from './events.quiz-question-card-ai';

export const cancelAbortReason = (by: QuestionCardAiCancelBy) =>
  new DOMException(by, 'AbortError');

export const cancelByOf = (signal: AbortSignal): QuestionCardAiCancelBy =>
  signal.reason instanceof DOMException && signal.reason.message === 'user'
    ? 'user'
    : 'unmount';
